import { TypologyValue } from '@/shared';

export const typeStyling = (type: TypologyValue): string => {
  switch (type) {
    case TypologyValue.Discovery:
      return 'bg-yellow-200 text-yellow-800';
    case TypologyValue.Development:
      return 'bg-turquoise-200 text-turquoise-800';
    case TypologyValue.Diligence:
      return 'bg-purple-200 text-purple-800';
    default:
      return '';
  }
};
